import React, { Component } from 'react';
import theme from '../../app.theme';
import ENV from '../../../run-config';
import pdfIcon from '../../../images/pdf_small.png';
import DateIcon from 'mdi-react/CalendarRangeIcon';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';
import InformationIcon from 'mdi-react/InformationVariantIcon';
import Tooltip from '@material-ui/core/Tooltip';


const HtmlTooltip = withStyles(theme => ({
    tooltip: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 500,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
}))(Tooltip);

const findTypeById = (list, id, type) => {
    if (!list) {
        return null;
    }

    let match = null;
    list.forEach((cg) => {
        if (cg.type == type && cg.id == id) {
            match = cg;
            return;
        }

        if (!match && cg.type === 'group') {
            match = findTypeById(cg.children, id, type);
        }
    });
    return match;
};

class Tile extends Component {

    formatDate = date => moment(date).format('DD.MM.YYYY') || null;

    renderExamInformation = () => {
        const { classes, description, exam } = this.props;
        const tooltipContent = (
            <div>
                <Typography className={classes.infoText} style={description && { marginBottom: 10 }}>{description}</Typography>

                {/* <Typography className={classes.infoText}>
                    <span className={classes.bold}>Startdatum: </span>
                    {this.formatDate(exam.startDate)}
                    </Typography>
                
                <Typography className={classes.infoText}>
                <span className={classes.bold}>Enddatum: </span>
                    {this.formatDate(exam.endDate)}</Typography> */}

                <Typography className={classes.infoText}>
                    <span className={classes.bold}>Prüfungsdauer (in Minuten): </span>
                    {exam.duration}
                </Typography>

                <Typography className={classes.infoText}>
                    <span className={classes.bold}>Erfolgreich ab: </span>
                    {Math.round(exam.test.scoreToPass * 100)}% richtige Antworten
                </Typography>
                {this.renderExamConditions()}
            </div>
        )

        return (
            <HtmlTooltip
                style={{ zIndex: 10 }}
                title={
                    <React.Fragment>
                        {tooltipContent}
                    </React.Fragment>
                }
            >
                <div>
                    <InformationIcon className={classes.infoIcon} />
                </div>
            </HtmlTooltip>
        )
    }

    // renderDaysRemaining = () => {
    //     const { exam, isUpcoming } = this.props;
    //     const dateToday = moment();
    //     const differenceInDays = moment(exam.endDate).diff(dateToday, 'days');
    //     if (isUpcoming) return <div />;

    //     return <Typography style={{ margin: 4}}>noch {differenceInDays} Tage</Typography>
    // }

    renderNumberOfAttempts = () => {
        const attempts = this.props.exam.numberOfAttemptsLeft

        if (attempts != -1) {
            return attempts === 1
                ? 'Es verbleibt 1 Versuch'
                : `Es verbleiben ${attempts} Versuche`;
        }

        return ''
    }

    renderDateOfNextTry = () => {
        const { exam, isUpcoming } = this.props;

        if (!isUpcoming) return null;
        const nextTry = moment(exam.nextAttemptPossibleDate);
        const today = moment();

        const differenceDates = nextTry.diff(today);

        if (differenceDates <= 0) return null;

        return `Nächster Versuch am: ${nextTry.format("DD.MM.YYYY HH:mm")}`
    }

    renderCourseConditions = () => {
        const { classes } = this.props;
        if (!this.props.exam.courseTriggers || this.props.exam.courseTriggers.length < 1) return null;

        const triggerList = this.props.exam.courseTriggers.map(t => {
            const course = findTypeById(this.props.courseGroups, t.courseId, 'course');
            if (!course) return null;

            return (<Typography>{course.name}</Typography>)
        })

        return (

            <Typography className={classes.infoText}>
                <span className={classes.bold}>Zu absolvierende Kurse</span>
                {triggerList}
            </Typography>
        )
    }

    renderTestConditions = () => {
        const { classes } = this.props;
        if (!this.props.exam.testTriggers || this.props.exam.testTriggers.length < 1) return null;

        const triggerList = this.props.exam.testTriggers.map(t => {
            const test = findTypeById(this.props.testGroups, t.testId, 'test');
            if (!test) return null;

            return (<Typography>{test.name}</Typography>)
        })

        return (
            <Typography className={classes.infoText}>
                <span className={classes.bold}>Zu bestehende Tests</span>
                {triggerList}
            </Typography>

        )
    }

    renderExamConditions = () => {
        if (!this.props.isUpcoming) return null;
        return (
            <div>
                {this.renderCourseConditions()}
                {this.renderTestConditions()}
            </div>
        )
    }

    render() {
        const { exam, classes, isUpcoming } = this.props;

        const containerStyle = {

            overflow: 'hidden',
            backgroundImage: `url(${this.props.imageUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            position: 'relative',
            cursor: !isUpcoming && 'pointer',
            zIndex: 4,
        };

        const additionalInformationStyle = {
            display: 'flex',
            background: 'RGBA(0,0,0,0.40)',
            justifyContent: 'space-between',
            alignItems: 'center',
            color: 'white'
        }

        return (
            <div className={'col-xs-6 col-sm-6 col-lg-3 col-md-4'} >
                <div className={classes.outerContainerStyle} onClick={isUpcoming ? () => { } : this.props.onClick}>
                    <div className="pm-card-v2" style={containerStyle}>
                        <div style={additionalInformationStyle}>
                            {/* {this.renderDaysRemaining()} */}
                            <div></div>
                            {this.renderExamInformation()}
                        </div>
                    </div>
                    {/* {this.renderProgressBar()} */}
                    <div style={{ backgroundColor: '#fff', height: 120, padding: 10 }} >
                        <span className={`pm-card-title-v2 ${classes.title}`}>{this.props.title && this.props.title.toUpperCase()}</span>
                        <Typography className={classes.dateContainer}>
                            {this.renderNumberOfAttempts()}
                            {/* DateIcon className={classes.iconStyle} /> */}
                            {/* Startet am: {this.formatDate(exam.startDate)} */}
                        </Typography>

                        <Typography className={classes.dateContainer}>
                            {this.renderDateOfNextTry()}
                            {/* <DateIcon className={classes.iconStyle} /> */}
                            {/* Endet am: {this.formatDate(exam.endDate)} */}
                        </Typography>
                        {/* {this.renderSubtitle()} */}
                    </div>
                </div>
            </div>
        );
    }
}

Tile.defaultProps = {
    title: '',
};

const styles = () => ({
    cardContainer: {
        // minHeight: 120,
    },
    bold: {
        fontWeight: 'bold',
    },
    dateContainer: {
        display: 'flex',
        alignContent: 'center',
        alignItems: 'center',
        marginTop: 5
    },
    iconStyle: {
        marginRight: 5,
        zIndex: 10,
        color: 'grey'
    },
    infoText: {
        margin: '5px 0 5px 0'
    },
    title: {
        marginTop: 5,
        marginBottom: 5,
        paddingRight: 15,
        bottom: '5px',
        width: '100%',
        hyphens: 'auto',
        WebkitHyphens: 'auto',
        wordWrap: 'break-word',
    },
    infoIcon: {
        height: 25,
        width: 25,
        // color: 'grey',
        margin: 4,
        float: 'right',
        zIndex: 1,
        // backgroundColor: 'rgba(255, 255, 255, 0.75)',
        // borderRadius: '100%'
    },
    outerContainerStyle: {
        position: 'relative',
        margin: 10,
        marginLeft: 0,
        minHeight: 300,
        borderBottomColor: '#ddd',
        borderBottomWidth: 1,
        borderRightColor: '#ddd',
        borderRightWidth: 1,
        borderRightStyle: 'solid',
        borderBottomStyle: 'solid',
        boxShadow: '-1px -4px 72px 8px rgba(115,115,115,0.07)',
        zIndex: 4,
    },
});

export default withStyles(styles)(Tile);



// WEBPACK FOOTER //
// ./src/app/components/tile/exam-tile.js